import { Dialog, Slide, Button, Card, CardContent, Box, Typography, IconButton } from "@mui/material"
import * as React from 'react';
import { LoggedIn, LoggedOut } from "./AccessControl";
import { useDispatch } from "react-redux";
import { setError } from "../actions/notificationActions";
import EmailField from "./EmailField";
import DownloadIcon from '@mui/icons-material/Download';
import CloseIcon from '@mui/icons-material/Close';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const ProductDownload = ({ open, onClose, productID, requireEmail, showSocialMedia = false }) => {

  const [showEmail, setShowEmail] = React.useState(true);
  const [showProductSuggestion, setShowProductSuggestion] = React.useState(false);

  const dispatch = useDispatch();

  const handleDownload = (os) => {
    if (productID === undefined) {
      dispatch(setError("Product ID unavailable, please contact support."))
      return;
    }
    const link = `/downloads/${os}/${productID}`
    const handle = window.open(link, "_blank")
    handle.blur()
    window.focus()
    setShowProductSuggestion(true);
    handleClose();
  }

  const handleWindowsDownload = () => {
    handleDownload("windows")
  }

  const handleMacDownload = () => {
    handleDownload("mac")
  }

  const handleClose = () => {
    setShowProductSuggestion(false);
    setShowEmail(true);
    onClose();
  }

  const skipMailingList = () => {
    setShowEmail(false);
  }

  const DownloadButtons = () => {
    return (
      <div>
        <Box sx={{ mt: 0, mb: 4, width: "100%", textAlign: "center" }}> <Typography variant="h6"> Select your platform  </Typography> </Box>
        <Button sx={{ width: "100%" }} onClick={handleWindowsDownload} variant="contained">Windows 64-bit</Button>

        <Box sx={{ mt: 1, mb: 1, width: "100%", textAlign: "center" }}> <Typography variant="subtitle1">or</Typography> </Box>
        <Button sx={{ width: "100%" }} onClick={handleMacDownload} variant="contained">MacOS</Button>
      </div>
    )
  }

  const SocialMediaPrompt = () => {
    return <div style={{ width: "100%", marginTop: 24 }}>
      {/* <Box sx={{ mt: 3, mb: 4, width: "100%", textAlign: "center" }}> <Typography variant="h6"> Like our work? <br />Follow us on social media to stay up to date with new content and giveaways!  </Typography> </Box> */}

      <Typography variant="caption" sx={{ color: "rgba(249, 245, 238, 0.72)" }}>You can also follow us for future updates.</Typography>
      <Box sx={{ display: "flex", p: 0, width: "100%", justifyContent: "center", mt: 0.5 }}>

        <IconButton aria-label="WaveMind on Facebook" href="https://www.facebook.com/people/WaveMind/100092637661925/" sx={{ color: "rgba(249, 245, 238, 0.82)" }}><FacebookIcon sx={{ height: 28, width: 28 }} /></IconButton>
        <IconButton aria-label="WaveMind on Instagram" href="https://www.instagram.com/wavemindnl/" sx={{ color: "rgba(249, 245, 238, 0.82)" }}><InstagramIcon sx={{ height: 28, width: 28 }} /></IconButton>
        <IconButton aria-label="WaveMind on YouTube" href="https://www.youtube.com/channel/UC9lKMgbHdEOcKXzS5UJT-GQ" sx={{ color: "rgba(249, 245, 238, 0.82)" }}><YouTubeIcon sx={{ height: 28, width: 28 }} /></IconButton>
      </Box>
    </div>
  }

  const ProductSuggestion = () => {
    return <div>
      <Box sx={{ mt: 0, mb: 4, width: "100%", textAlign: "center" }}> <Typography variant="h6"> Your download has started, in the mean time   </Typography> </Box>
      <Button sx={{ width: "100%" }} onClick={handleWindowsDownload} variant="contained">Windows 64-bit</Button>

      <Box sx={{ mt: 1, mb: 1, width: "100%", textAlign: "center" }}> <Typography variant="subtitle1">or</Typography> </Box>
      <Button sx={{ width: "100%" }} onClick={handleMacDownload} variant="contained">MacOS</Button>
    </div>
  }

  const EmailInput = () => {
    return (
      <Box sx={{ width: "100%" }}>
        <Box sx={{ mb: 2.5, width: "100%", textAlign: "center" }}>
          <Box sx={{ alignItems: "center", backgroundColor: "rgba(249, 245, 238, 0.09)", borderRadius: "50%", display: "inline-flex", height: 46, justifyContent: "center", mb: 1.5, width: 46 }}>
            <MailOutlineIcon sx={{ fontSize: 24 }} />
          </Box>
          <Typography id="mailing-list-title" variant="h6" sx={{ fontSize: "1.25rem", fontWeight: 550 }}>Would you like to join our mailing list?</Typography>
          <Typography variant="caption" sx={{ color: "rgba(249, 245, 238, 0.72)", display: "block", fontSize: "0.7rem", mt: 0.75 }}>We’ll occasionally send product news and updates.</Typography>
        </Box>

        <EmailField sx={{ display: "flex", width: "100%" }} onSubmit={() => setShowEmail(false)} buttonText="Subscribe" labelText="Your Email" source={productID} />
        <Typography variant="caption" sx={{ color: "rgba(249, 245, 238, 0.62)", display: "block", lineHeight: 1.5, px: 1 }}>
          By subscribing, you agree to our <a style={{ color: "inherit", textDecoration: "underline" }} href="/privacy">privacy policy</a>.
        </Typography>

        <Button startIcon={<DownloadIcon />} onClick={skipMailingList} sx={{ borderColor: "rgba(249, 245, 238, 0.28)", color: "inherit", mt: 2.5, textTransform: "none", width: "100%", '&:hover': { borderColor: "rgba(249, 245, 238, 0.6)", backgroundColor: "rgba(249, 245, 238, 0.05)" } }} variant="outlined">
          No thanks, continue to download
        </Button>

        <Box sx={{ alignItems: "center", display: "flex", justifyContent: "center", mt: 2.5 }}>
          <Typography variant="caption" sx={{ color: "rgba(249, 245, 238, 0.72)" }}>Already have an account?</Typography>
          <Button href="/login?redirect=store" size="small" sx={{ minWidth: 0, ml: 0.5, p: 0.5, textTransform: "none" }} variant="text">Log in</Button>
        </Box>
      </Box>
    )
  }

  return <Dialog
    open={open}
    onClose={handleClose}
    TransitionComponent={Transition}
    aria-labelledby={requireEmail && showEmail ? "mailing-list-title" : undefined}
    PaperProps={{ sx: { background: "transparent", boxShadow: "none", m: 2, overflow: "visible" } }}
  >
    {/* <LoggedOut>
      <Card sx={{ minWidth: "300px", p: 3, background: "radial-gradient(circle, rgb(60, 60, 60)0%, rgb(30, 30, 30) 100%)" }} >
        <CardContent>
          <Typography sx={{ mb: 4 }}> A WaveMind account is required to activate your trial</Typography>
          <Box sx={{ mt: 0, mb: 1, width: "100%", textAlign: "center" }}> <Typography variant="h6">Account </Typography> </Box>
          <Button sx={{ width: "100%" }} href={`/login?redirect=${window.location.pathname}`} variant="contained">Log In</Button>

          <Box sx={{ mt: 1, mb: 1, width: "100%", textAlign: "center" }}> <Typography variant="subtitle1">or</Typography> </Box>
          <Button sx={{ width: "100%" }} href="/register" variant="contained">Create Account</Button>
        </CardContent>
      </Card>
    </LoggedOut> */}
    {/* <LoggedIn> */}

    <Card sx={{ background: "linear-gradient(145deg, rgb(43, 43, 43) 0%, rgb(24, 24, 24) 100%)", border: "1px solid rgba(249, 245, 238, 0.13)", borderRadius: 3, boxShadow: "0 24px 70px rgba(0, 0, 0, 0.5)", minWidth: { xs: "calc(100vw - 32px)", sm: "520px" }, maxWidth: "560px", position: "relative", textAlign: "center" }}>
      <IconButton aria-label="Close download dialog" onClick={handleClose} sx={{ color: "rgba(249, 245, 238, 0.68)", position: "absolute", right: 8, top: 8, zIndex: 1, '&:hover': { color: "rgb(249, 245, 238)", backgroundColor: "rgba(249, 245, 238, 0.08)" } }}>
        <CloseIcon fontSize="small" />
      </IconButton>
      <CardContent sx={{ p: { xs: 3, sm: 4 }, pb: showSocialMedia ? { xs: 2, sm: 2.5 } : { xs: 3, sm: 4 }, '&:last-child': { pb: showSocialMedia ? { xs: 2, sm: 2.5 } : { xs: 3, sm: 4 } } }}>
        <LoggedIn>
          <DownloadButtons />
        </LoggedIn>
        <LoggedOut>
          {requireEmail && showEmail === true && <EmailInput />}
          {(!requireEmail || !showEmail) && <DownloadButtons />}
          {(requireEmail && !showEmail && showProductSuggestion) && <ProductSuggestion />}

          {showSocialMedia && <SocialMediaPrompt />}



        </LoggedOut>
      </CardContent>
    </Card>
    {/* </LoggedIn> */}
  </Dialog >
}

export default ProductDownload;
